export default "__VITE_ASSET__BT2jCYW7__"